/**
 * 名字旁边那一小行区分的字（SAME-NAME-LABEL-117，口径见 ./sameNameTags）：只在这一屏有同名、这一位是平台居民时才有。
 * 读屏连着名字念「豆豆，西安居民」：前面一个看不见的逗号；字本身看得见（只靠颜色、位置区分不算数）。
 * 不换行、不截断名字：小字自己可以缩，名字不让。颜色只用令牌，对卡面 ≥4.5:1（--c-ink-2）。
 */
import "./same-name.css";

export function SameNameTag({ tag }: { tag: string | null | undefined }) {
  if (!tag) return null;
  return (
    <span className="ps-same-name" data-same-name>
      <span className="visually-hidden">，</span>
      {tag}
    </span>
  );
}
